export default "__VITE_ASSET__yH8noaLE__"